.list {
  display: flex;
  align-items: center;
  max-width: calc(100vw - 64px);
  overflow-x: hidden;
}

.item {
  font-size: var(--font-size-sm);
  color: #bfc9d7;
  white-space: nowrap;
  transition: color 0.2s;

  &:hover {
    color: var(--color-white);
  }

  &:not(:nth-of-type(11))::after {
    height: 13px;
    margin-inline: 9.5px;
    content: '';
    border-left: 1px solid #bfc9d7;
  }
}

.more {
  height: 21px;
  overflow-y: hidden;
  font-size: var(--font-size-sm);
  font-weight: bold;
  color: #bfc9d7;
  transform: translateY(-4px);

  @media (width >= 981px) {
    display: none;
  }
}

.hiddenWhenSmallerThan800 {
  @media (width <= 800px) {
    display: none;
  }
}

.hiddenWhenSmallerThan860 {
  @media (width <= 860px) {
    display: none;
  }
}

.hiddenWhenSmallerThan920 {
  @media (width <= 920px) {
    display: none;
  }
}

.hiddenWhenSmallerThan980 {
  @media (width <= 980px) {
    display: none;
  }
}
